import { MiniBetSlipSchema } from './MiniBetSlip.styles';

export const miniBetSlipStyles: MiniBetSlipSchema = {
  wrapper: {
    mx: ['0', '-3'],
    bottom: ['15px', null, '0'],
    left: '0',
    position: ['fixed', null, null, 'sticky'],
    right: '0',
    zIndex: 'sticky',
  },
  slideBox: {
    bg: 'alpha.500',
    color: 'white',
    mb: '-4',
  },
  accordionItem: {
    borderTopWidth: '0',
    _last: {
      borderBottomWidth: '0',
    },
  },
  accordionHeaderText: {
    boxShadow:
      '0 1px rgba(255, 255, 255, .15), 0 1px rgba(255, 255, 255, .15) inset',
  },
  accordionButton: {
    bgGradient: 'linear(to-b, #FFE6B6, beta.500)',
    fontSize: 'xs',
    fontWeight: 'bold',
    gap: '1',
    p: '2',
    color: 'beta.600',
    _hover: {
      bgGradient: 'linear(to-b, beta.500, beta.400)',
    },
  },
  accordionButtonIcon: {
    fontSize: 'sm',
  },
  headerStack: {
    bg: 'alpha.900',
    borderRadius: 'base',
    bottom: '100%',
    fontSize: 'xs',
    fontWeight: 'medium',
    left: '50%',
    pos: 'absolute',
    px: '4',
    py: '2',
  },
  headerText: {
    flex: '1',
  },
  headerButton: {
    display: 'inline-flex',
    fontSize: 'xl',
    minW: '0',
  },
  accordionPanel: {
    fontSize: 'xs',
    maxH: '32',
    overflow: 'auto',
    p: '0',
  },
  selectionFlex: {
    borderColor: 'blackAlpha.300',
    gap: '2',
    p: '2',
    pos: 'relative',
    _notFirst: {
      borderTopStyle: 'dotted',
      borderTopWidth: '1px',
    },
    _before: {
      border: 'inherit',
      borderColor: 'whiteAlpha.300',
      content: '""',
      h: '1px',
      left: '0',
      pos: 'absolute',
      right: '0',
      top: '0',
    },
  },
  selectionMarketName: {
    flex: '1',
    fontWeight: 'bold',
  },
  selectionPropositionName: {
    flex: ['1', null, '2', null, '3'],
  },
  footerStack: {
    bgGradient:
      'linear(to-b, rgba(194, 223, 255, 0.10) 0%, rgba(194, 223, 255, 0.00) 100%)',
    direction: 'row',
    fontSize: 'sm',
    fontWeight: 'semibold',
    py: '2.5',
    px: ['2', null, '4'],
    pos: 'relative',
    borderTopColor: 'blackAlpha.300',
    _before: {
      bgGradient: 'linear(to-b, rgba(0, 0, 0, 0.00), #000)',
      opacity: '0.2',
      bottom: 'calc(100% + 1px)',
      content: '""',
      h: '4',
      left: '0',
      pointerEvents: 'none',
      pos: 'absolute',
      right: '0',
      transitionDuration: 'normal',
      transitionProperty: 'common',
    },
  },
  footerHStack: {
    flex: '1',
  },
  legsText: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    color: 'white',
    textTransform: 'uppercase',
  },
  legsChunks: {
    color: 'beta.400',
    textShadow: '0px 1px 1px rgba(0, 0, 0, 0.30)',
    fontSize: 'md',
    fontWeight: 'black',
  },
  oddsText: {
    color: 'white',
    textTransform: 'uppercase',
    flex: '2',
    display: 'flex',
    flexDirection: 'column',
    fontSize: ['xs', null, 'sm'],
  },
  oddsSkeletonLoader: {
    display: 'inline-block',
    ml: '1',
    w: '8',
  },
  oddsChunks: {
    color: 'beta.400',
    fontSize: 'md',
    fontWeight: 'black',
    ml: '1',
  },
  clearButton: {
    variant: 'outline',
    borderColor: 'white',
    textTransform: 'uppercase',
    borderRadius: 'md',
    h: '9',
    mr: 2,
    fontSize: ['xs', null, 'sm'],
    fontFamily: 'Fraunces',
    textShadow: '0px 1px 2px rgba(0, 0, 0, 0.40)',
  },
  addToSlipButton: {
    variant: 'tertiary',
    fontSize: ['xs', null, 'sm'],
    sx: {
      '&&': {
        ml: ['1', null, '0'],
      },
    },
  },
};
